<div class="row">
    <app-sidebar></app-sidebar>
    <div class="flex_item">
      <app-header></app-header>
      <router-outlet></router-outlet>
    </div>
  </div>
  